module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-form"
  }, [(_vm.loading) ? _c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dialogMode) ? _c('source-dialog-header', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.loading
    },
    on: {
      "load-article": _vm.getElibraryArticle,
      "load-digital-resource": _vm.getDigitalResource,
      "input": function($event) {
        _vm.$emit('input', arguments[0])
      }
    }
  }) : _c('source-dialog-expanded-header', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.loading
    },
    on: {
      "load-article": _vm.getElibraryArticle,
      "load-digital-resource": _vm.getDigitalResource,
      "toggle-custom": _vm.onToggleCustom
    }
  }), _vm._v(" "), _c('source-dialog-custom', {
    class: {
      'custom-toggable': !_vm.dialogMode, 'hidden': !_vm.showCustom
    },
    attrs: {
      "value": _vm.value,
      "disabled": _vm.loading
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', arguments[0])
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd8c112e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceDialogForm.vue
// module id = 1026
// module chunks = 1